/**
 * Gets the transformation applied to a given element.
 */
export const getElementTransformation = (
  element: Element,
): { scale: number; translate: { x: number; y: number } } => {
  try {
    const m = new DOMMatrix(window.getComputedStyle(element).transform)
    /**
     * See https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
     *
     * The computed transform will be a 2d matrix where the first 4 values describe
     * the linear transformation and the final 2 values descibe an x/y translation.
     *
     * The first value can only be guaranteed to be the scale value if there is
     * no skewing or rotation applied to the element. At the time of writing,
     * we never skew or rotate so this is a safe assumption.
     */
    return { scale: m.a, translate: { x: m.e, y: m.f } }
  } catch {
    /**
     * If there is no matrix, then there is no transformation applied to the
     * element. So we return an 'identity' transformation.
     * See https://en.wikipedia.org/wiki/Identity_matrix
     */
    return { scale: 1, translate: { x: 0, y: 0 } }
  }
}
